import { useState, useEffect, lazy, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import "./css/Layout.css";
import "./css/Master.css";
import api from "./api/api";

function Layout() {

  const [menuData, setMenuData]   = useState([]);
  const [menu, setMenu]           = useState("");
  const [submenu, setSubmenu]     = useState("");
  const [Component, setComponent] = useState(null);
  const [navOpen, setNavOpen]     = useState(true);   // ← topnav toggle

  const navigate = useNavigate();

  // Fetch menu from API
useEffect(() => {

  const fetchMenu = async () => {

    try {

      const res = await api.get("/Menu/getmenu");

      const data = res.data;

      const menuMap = {};

      data.forEach(item => {

        if (!menuMap[item.menu_key]) {
          menuMap[item.menu_key] = {
            menu_name: item.menu_name,
            menu_key: item.menu_key,
            submenus: []
          };
        }

        if (item.submenu_name && item.filename) {
          menuMap[item.menu_key].submenus.push({
            submenu_name: item.submenu_name,
            filename: item.filename
          });
        }

      });

      setMenuData(Object.values(menuMap));

    } catch (err) {

      console.error("Menu API Error:", err);

    }

  };

  fetchMenu();

}, []);
  // Logout
 const handleLogout = () => {
  localStorage.clear();
  navigate("/");
};

  // Dynamic component loader
  const loadComponent = (file) => {
    if (!file) return;
    const DynamicComponent = lazy(() => import(`./${file}.js`));
    setSubmenu(file);
    setComponent(() => DynamicComponent);
  };

  // Active menu name (for topnav toggle label)
  const activeMenuName = menuData.find(m => m.menu_key === menu)?.menu_name || "";

  return (

    <div className="layout-container">

      {/* ── Sidebar ───────────────────────────────────────────── */}
      <div className="sidebar">

        <h2 className="menu-title">Menu Bar</h2>

        {menuData.map((m) => (
          <button
            key={m.menu_key}
            className={menu === m.menu_key ? "active" : ""}
            onClick={() => {
              setMenu(m.menu_key);
              setSubmenu("");
              setComponent(null);
              setNavOpen(true);   
            }}
          >
            {m.menu_name}
          </button>
        ))}

        <div className="sidebar-bottom">
          <button className="logout-btn" onClick={handleLogout}>
            ⏻ &nbsp;Logout
          </button>
        </div>

      </div>

      {/* ── Content Area ──────────────────────────────────────── */}
      <div className="content">

        {/* Top Navigation */}
        {menu && (
          <div className="topnav">

            {/* Toggle bar — always visible */}
            <button
              className="topnav-toggle"
              onClick={() => setNavOpen(o => !o)}
            >
              <span className="topnav-toggle-icon">{navOpen ? "▲" : "▼"}</span>
              {activeMenuName}
            </button>

            {/* Submenu items — collapsible */}
            {navOpen && (
              <div className="nav-container">
                {menuData
                  .find(m => m.menu_key === menu)
                  ?.submenus
                  ?.map((s, index) => (
                    <div
                      key={index}
                      className={submenu === s.filename ? "nav-item active" : "nav-item"}
                      onClick={() => loadComponent(s.filename)}
                    >
                      {s.submenu_name}
                    </div>
                  ))}
              </div>
            )}

          </div>
        )}

        {/* Page Content */}
        <div className="page-content">
          {Component && (
            <Suspense fallback={<h3>Loading...</h3>}>
              <Component />
            </Suspense>
          )}
        </div>

      </div>

    </div>

  );
}

export default Layout;
